export default __webpack_public_path__ + "static/media/pic3.eb657c64.jpg";